<div class="panel panel-default">
  <div class="panel-heading">
    <h4 class="margin-top-0 margin-bottom-0">
      {{ appCopy.panelHeader['timeslotsText'+selectedLanguage] }}
    </h4>
  </div>
  <!-- <div class="panel-body" *ngIf="!bookingDetailsAdminLoaded">
    <div class="loader-container">
      <div class="loader">
        <svg class="circular" viewBox="25 25 50 50">
          <circle class="path" cx="50" cy="50" r="20" />
        </svg>
      </div>
    </div>
  </div> -->
  <div class="panel-body">
      <form #formCSTimeslots="ngForm" name="formCSTimeslots" (submit)="handleTimeslotSubmit(formCSTimeslots.value, $event)" novalidate>

        <!-- Outbound - Airport delivery - Repatriation -->
        <div *ngIf="flightDirection === 1">
          <p *ngIf="!showRepatriationEdit">{{ appCopy.panelHeader['repatriationText'+selectedLanguage] }}: {{ timeslot.original.repatriation | amDateFormat: 'Do MMMM HH:mm' }}<br>
            <a *ngIf="!showRepatriationEdit" href="javascript:void(0);" (click)="showRepatriationEdit = !showRepatriationEdit; isEditable = !isEditable">{{ appCopy.panelHeader['editButton'+selectedLanguage] }}</a>
          </p>
          <p *ngIf="showRepatriationEdit"><a href="javascript:void(0);" (click)="showRepatriationEdit = !showRepatriationEdit; isEditable = !isEditable">{{ appCopy.panelHeader['cancelButton'+selectedLanguage] }}</a></p>

          <div *ngIf="showRepatriationEdit">
            <p>{{ appCopy.panelHeader['currentRepatriationText'+selectedLanguage] }}: {{ timeslot.original.repatriation | amDateFormat: 'Do MMMM HH:mm' }}</p>
            
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group with-select">
                  <select #repatriationHours
                    class="form-control"
                    id="repatriationHours"
                    name="repatriationHours"
                    [(ngModel)]="timeslot.updated.hours">
                    <option value="" disabled></option>
                    <option value="00">00</option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                  </select>
                  <label class="control-label" for="repatriationHours">{{ appCopy.panelHeader['repatriationHoursLabel'+selectedLanguage] }}</label>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group with-select">
                  <select #repatriationMinutes
                    class="form-control"
                    id="repatriationMinutes"
                    name="repatriationMinutes"
                    [(ngModel)]="timeslot.updated.minutes">
                    <option value="" disabled></option>
                    <option value="00">00</option>
                    <option value="05">05</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="20">20</option>
                    <option value="25">25</option>
                    <option value="30">30</option>
                    <option value="35">35</option>
                    <option value="40">40</option>
                    <option value="45">45</option>
                    <option value="50">50</option>
                    <option value="55">55</option>
                  </select>
                  <label class="control-label" for="repatriationMinutes">{{ appCopy.panelHeader['repatriationMinutesLabel'+selectedLanguage] }}</label>
                </div>
              </div>
            </div>
            <div class="form-group">
              <app-datepicker
                [selectedDate]="timeslot.original.repatriation"
                [minDate]="minDate"
                [maxDate]="maxDate"
                [disableDates]="disableDates"
                labelText="Repatriation Date"
                (dateChange)="dateChanged($event)">
              </app-datepicker>
            </div>
          </div>
        </div>

        <!-- Inbound - City delivery - Acceptance -->
        <div *ngIf="flightDirection === 2">
          <p *ngIf="!showAcceptanceEdit">{{ appCopy.panelHeader['acceptanceText'+selectedLanguage] }}: {{ timeslot.original.acceptance | amDateFormat: 'Do MMMM HH:mm' }}<br>
            <a *ngIf="!showAcceptanceEdit" href="javascript:void(0);" (click)="showAcceptanceEdit = !showAcceptanceEdit; isEditable = !isEditable">{{ appCopy.panelHeader['editButton'+selectedLanguage] }}</a>
          </p>
          <p *ngIf="showAcceptanceEdit"><a href="javascript:void(0);" (click)="showAcceptanceEdit = !showAcceptanceEdit; isEditable = !isEditable">{{ appCopy.panelHeader['cancelButton'+selectedLanguage] }}</a></p>

          <div *ngIf="showAcceptanceEdit">
            <p>{{ appCopy.panelHeader['currentAcceptanceText'+selectedLanguage] }}: {{ timeslot.original.acceptance | amDateFormat: 'Do MMMM HH:mm' }}</p>

            <div class="row">
              <div class="col-sm-6">
                <div class="form-group with-select">
                  <select #acceptanceHours
                    class="form-control"
                    id="acceptanceHours"
                    name="acceptanceHours"
                    [(ngModel)]="timeslot.updated.hours">
                    <option value="" disabled></option>
                    <option value="00">00</option>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                    <option value="13">13</option>
                    <option value="14">14</option>
                    <option value="15">15</option>
                    <option value="16">16</option>
                    <option value="17">17</option>
                    <option value="18">18</option>
                    <option value="19">19</option>
                    <option value="20">20</option>
                    <option value="21">21</option>
                    <option value="22">22</option>
                    <option value="23">23</option>
                  </select>
                  <label class="control-label" for="acceptanceHours">{{ appCopy.panelHeader['acceptanceHoursLabel'+selectedLanguage] }}</label>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group with-select">
                  <select #acceptanceMinutes
                    class="form-control"
                    id="acceptanceMinutes"
                    name="acceptanceMinutes"
                    [(ngModel)]="timeslot.updated.minutes">
                    <option value="" disabled></option>
                    <option value="00">00</option>
                    <option value="05">05</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="20">20</option>
                    <option value="25">25</option>
                    <option value="30">30</option>
                    <option value="35">35</option>
                    <option value="40">40</option>
                    <option value="45">45</option>
                    <option value="50">50</option>
                    <option value="55">55</option>
                  </select>
                  <label class="control-label" for="acceptanceMinutes">{{ appCopy.panelHeader['acceptanceMinutesLabel'+selectedLanguage] }}</label>
                </div>
              </div>
            </div>

            <div class="form-group">
              <app-datepicker
                [selectedDate]="timeslot.original.acceptance"
                [minDate]="minDate"
                [maxDate]="maxDate"
                [disableDates]="disableDates"
                labelText="Acceptance Date"
                (dateChange)="dateChanged($event)">
              </app-datepicker>
            </div>

          </div>
        </div>

        <button id="adminTimeslot-submit" type="submit" class="btn btn-accent btn-lg btn-block" [disabled]="isLoading || !isEditable">
          <div class="loader-container-btn" *ngIf="isLoading">
            <div class="loader loader--white">
              <svg class="circular" viewBox="25 25 50 50">
                <circle class="path" cx="50" cy="50" r="20" />
              </svg>
            </div>
          </div>
          {{ appCopy.panelHeader['confirm'+selectedLanguage] }}
        </button>

      </form>
  </div>
</div>